import React from "react"
import { Row, Col } from 'antd'
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom'
import "../../../assets/css/app.css"


import SignIn from '../../auth/signIn'
import SignUp from '../../auth/signUp'
import ForgetPassword from "../../auth/forgetPassword"

import userStore from "../../../store/slice/auth.slice"

import {Loader } from '../../utility/componentUtility'

function authLayout() {
    const loading = userStore((state) => state.loading)

    return (

        <div className="login_signup_container">
            <Row>
                <Col xs={0} sm={0} md={12}>
                    <div className="Login_screen_1st_col">
                        <div className="jubilee-logo"><img alt="" src="/assets/images/background/jubilee-logo.svg" /></div>
                    </div>
                </Col>

                <Col xs={24} sm={24} md={12}>
                    {loading ? <Loader /> : ''}
                    <div className="Login_screen_2nd_col">
                        <div className="form-container">
                            <div className="login-signup-heading">
                                <h2>WELCOME TO</h2>
                            </div>
                            <div className="agent-portal-heading"><h3>BRANCH PORTAL</h3></div>
                            <Routes>
                                <Route exact="true" path="/" element={ <SignIn />} />
                                <Route exact="true" path="/signin" element={ <SignIn />} />
                                <Route exact="true" path="/signup" element={ <SignUp />} />
                                <Route exact="true" path="/forgetpassword" element={ <ForgetPassword />} />
                                <Route path='*' element={<Navigate to="/404" />}/>
                            </Routes>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>

    )
}

export default authLayout